var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonOutline24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 2.66602C6.52699 2.66602 5.33366 3.85935 5.33366 5.33268C5.33366 6.80602 6.52699 7.99935 8.00033 7.99935C9.47366 7.99935 10.667 6.80602 10.667 5.33268C10.667 3.85935 9.47366 2.66602 8.00033 2.66602ZM9.40033 5.33268C9.40033 4.55935 8.77366 3.93268 8.00033 3.93268C7.22699 3.93268 6.60033 4.55935 6.60033 5.33268C6.60033 6.10602 7.22699 6.73268 8.00033 6.73268C8.77366 6.73268 9.40033 6.10602 9.40033 5.33268ZM12.067 11.3327C12.067 10.906 9.98033 9.93268 8.00033 9.93268C6.02033 9.93268 3.93366 10.906 3.93366 11.3327V12.066H12.067V11.3327ZM2.66699 11.3327C2.66699 9.55935 6.22033 8.66602 8.00033 8.66602C9.78033 8.66602 13.3337 9.55935 13.3337 11.3327V12.666C13.3337 13.0327 13.0337 13.3327 12.667 13.3327H3.33366C2.96699 13.3327 2.66699 13.0327 2.66699 12.666V11.3327Z",
    fill: "#55AA8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOutline24Px);
export default __webpack_public_path__ + "static/media/person_outline_24px.4416da053f4d8519fc402e235b67533d.svg";
export { ForwardRef as ReactComponent };